import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setup from "./utils/setup";

setup(Vue);
Vue.use(VueMeta);

const fahrzeugId = new URLSearchParams(window.location.search).get("fahrzeug");
let fahrzeugRedirectDone = false;

router.beforeEach((to, from, next) => {
  if (fahrzeugId && !fahrzeugRedirectDone && to.name !== "fahrzeug") {
    fahrzeugRedirectDone = true;
    next({ name: "fahrzeug", params: { id: fahrzeugId }, replace: true });
  } else {
    next();
  }
});

if (fahrzeugId) {
  // Drop the now-redundant "?fahrzeug=" param once the hash route has taken over.
  router.afterEach(() => {
    if (window.location.search) {
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + window.location.hash,
      );
    }
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
